import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { apiClient } from "@/shared/api/client"
import type { Post } from "@/shared/lib/types"

export interface Favorite {
	id: string
	userId: string
	postId: string
	createdAt: string
	post: Post
}

export const useFavorites = () => {
	return useQuery<Favorite[]>({
		queryKey: ["favorites"],
		queryFn: async () => {
			const response = await apiClient.get("/favorites")
			return response.data
		},
	})
}

export const useAddFavorite = () => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: async (postId: string) => {
			const response = await apiClient.post(`/favorites/${postId}`)
			return response.data
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["favorites"] })
			queryClient.invalidateQueries({ queryKey: ["favorite-ids"] })
		},
	})
}

export const useRemoveFavorite = () => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: async (postId: string) => {
			const response = await apiClient.delete(`/favorites/${postId}`)
			return response.data
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["favorites"] })
			queryClient.invalidateQueries({ queryKey: ["favorite-ids"] })
		},
	})
}

export const useFavoriteIds = () => {
	return useQuery<string[]>({
		queryKey: ["favorite-ids"],
		queryFn: async () => {
			const response = await apiClient.get("/favorites/ids")
			return response.data
		},
	})
}
